import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    typeLists: []
};
const getters = {
    contfundType: state => state.typeLists

};

const mutations = {
    FUND_TYPE_INFO(state, data) {
        state.typeLists = data
    }
};

const actions = {
    contfundType(context) {
        axiosGet(`crm/fund/types`).then((response) => {
            context.commit('FUND_TYPE_INFO', response.data.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
